<template>
  <ModalConfirmSwal
    v-if="show"
    :header-text="$t('Send invitation?')"
    :text="$t('Do you want to send an invitation to onboard?')"
    :confirm-button-text="$t('Yes, send')"
    :processing-text="$t('Sending invitation')"
    @confirmed="handleConfirmed"
    @cancelled="$emit('close')"
  />
</template>

<script setup lang="ts">
import { useMutation } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import swal from 'sweetalert'

import ModalConfirmSwal from '@/components/ModalConfirmSwal.vue'
import { $t } from '@/composables/translation'

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },

  trustedContactId: {
    type: [String, null],
    required: true,
  },
})

const emit = defineEmits(['close', 'invited'])

const { mutate: reInviteTrustedContact, error: reInviteTrustedContactError } = useMutation(
  gql`
    mutation ReinviteTrustedContactMutation($id: ID!) {
      reinviteTrustedContact(input: { id: $id }) {
        id
        status
      }
    }
  `,
  {
    clientId: 'publicApi',
  },
)

const handleConfirmed = async () => {
  await reInviteTrustedContact({
    id: props.trustedContactId,
  })

  if (reInviteTrustedContactError.value) {
    swal({
      title: $t('Error'),
      text: $t('The invitation was not successfully sent'),
      type: 'error',
      showConfirmButton: false,
      allowOutsideClick: true,
    })
  } else {
    emit('invited')

    swal({
      title: $t('Success'),
      text: $t('The invitation was successfully sent'),
      type: 'success',
      showConfirmButton: false,
      allowOutsideClick: true,
      timer: 5000,
    })
  }
}
</script>
